<template lang="pug">
  SspLayout(area="core")
    template(slot="actions")
      router-link.btn.btn-default(:to="{name: 'editSection', params: {orderId, sectionId}}")
        i.fa.fa-edit
        span.ml5 Edit
      router-link.btn.btn-default(:to="{name: 'sectionMetadata', params: {orderId, sectionId}}")
        i.fa.fa-code
        span.ml5 Metadata
      router-link.btn.btn-default(:to="{name: 'messages', params: {orderId, sectionId}}")
        i.fa.fa-envelope-o
        span.ml5 Messages
      button.btn.btn-default(@click="$refs.recallSectionModal.open()")
        i.fa.fa-repeat
        span.ml5 Recall
      router-link.btn.btn-default(:to="{name: 'geofenceSection', params: {orderId, sectionId}}")
        i.fa.fa-globe
        span.ml5 Geofence
      button.btn.btn-danger(@click="deleteSection")
        i.fa.fa-times
        span.ml5 Remove
    .row
      .col-sm-8
        SectionDetails(:section="section" :firstCodeBundle="firstCodeBundle" :lastCodeBundle="lastCodeBundle")

      .col-sm-4
        .panel.panel-default
          .panel-heading
            .panel-title Activation
          .panel-body(v-if="section")
            .container-fluid
              .row
                label.col-sm-6.control-label Activated
                .col-sm-6 {{section.enabled ? 'Yes' : 'No'}}
              .row
                label.col-sm-6.control-label Validation Limit
                .col-sm-6 {{ maxValidations }}
                .col-sm-6
              .row
                label.col-sm-6.control-label Activation Ordered
                .col-sm-6 {{section.activationOrdered | date}}
              hr
              .row
                label.col-sm-6.control-label(:title="timezone") Activation Date
                .col-sm-6 {{section.activateDate | date}}
              .row
                label.col-sm-6.control-label(:title="timezone") Deactivation Date
                .col-sm-6 {{section.deactivateDate | date}}
    .row
      .col-sm-8
        BundleDetails(:firstCodeBundle="firstCodeBundle" :lastCodeBundle="lastCodeBundle")

    RecallSectionModal(ref="recallSectionModal" :sectionId="sectionId" @success="init")
</template>

<script>
import miniToastr from 'mini-toastr'
import Util from '@/service/Util'
import Core from '@/service/apis/Core'
import { dateFilter } from '@/filters/filters'
import SectionDetails from './SectionDetails'
import BundleDetails from './BundleDetails'
import RecallSectionModal from './RecallSectionModal'


export default {
  data: () => ({
    section: null,
    firstCodeBundle: [],
    lastCodeBundle: []
  }),
  created() {
    this.init()
  },
  methods: {
    init() {
      Core.getSection(this.sectionId)
        .then((resp) => {
          this.section = resp.data
          return this.section
        })
        .then((section) => {
          Core.getCodeBundle(this.orderId, section.first.codeIndex)
            .then((resp) => {
              this.firstCodeBundle = resp.data
            })
          Core.getCodeBundle(this.orderId, section.last.codeIndex)
            .then((resp) => {
              this.lastCodeBundle = resp.data
            })
        })
        .catch((e) => {
          this.$emit('error', e)
        })
    },
    deleteSection() {
      this.$confirm({ text: 'Are you sure you want to delete this section?' })
        .then((conf) => {
          if (conf) {
            Core.deleteSection(this.sectionId)
              .then(() => {
                miniToastr.success('Section was deleted')
                this.$router.push({ name: 'sections', params: { id: this.orderId } })
              })
              .catch((e) => {
                this.$emit('error', e)
              })
          }
        })
    }
  },
  computed: {
    orderId() {
      return parseInt(this.$route.params.orderId, 10)
    },
    sectionId() {
      return parseInt(this.$route.params.sectionId, 10)
    },
    maxValidations() {
      if (!this.section.maxValidations || this.section.maxValidations === null) {
        return '∞'
      }
      return this.section.maxValidations
    },
    timezone() {
      return Util.timezone()
    }
  },
  components: {
    SectionDetails,
    BundleDetails,
    RecallSectionModal
  },
  filters: {
    date: dateFilter
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/core/order/section/Section.vue